module.exports = __webpack_public_path__ + "static/assets/access_control_default_bg.b66267a.jpg";